import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import FdPageHero from "./components/FdPageHero";
import FdIntroSection from "./components/FdIntroSection";
import FdWhatWeProvideSection from "./components/FdWhatWeProvideSection";
import FdAdvantagesSection from "./components/FdAdvantagesSection";
import FdHowItWorksSection from "./components/FdHowItWorksSection";
import FdAppShowcaseSection from "./components/FdAppShowcaseSection";
import FdModulesSection from "./components/FdModulesSection";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import FdCtaBanner from "./components/FdCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "../HospitalManagementPage/hospital-management.css";
import "./food-delivery.css";

const FoodDeliveryPage: React.FC = () => {
  useEffect(() => {
    document.title =
      "Food Delivery Website & App | WebTech Software Solutions Bangalore";
    const description =
      "WebTech builds multi-vendor food ordering and delivery apps in Bangalore — Swiggy, Zomato, and UberEats clone with customer, driver, merchant, and admin apps.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <FdPageHero />
            <FdIntroSection />
            <FdWhatWeProvideSection />
            <FdAdvantagesSection />
            <FdHowItWorksSection />
            <FdAppShowcaseSection />
            <FdModulesSection />
            <WdevTestimonials />
            <FdCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default FoodDeliveryPage;
